import { cn } from '../../lib/utils'
import { Checkbox } from './checkbox'
import { Label } from './label'
import { RadioGroupItem } from './radio-group'

export interface RadioOptionProps {
	value: string
	id: string
	label: string
	bordered?: boolean
}

function RadioOption({ value, id, label, bordered = true }: RadioOptionProps) {
	return (
		<Label
			htmlFor={id}
			className={cn(
				'relative flex items-center gap-2 cursor-pointer',
				bordered && 'items-start rounded-md border border-(--color-border) p-3',
			)}
			onClick={(e) => { if (!e.isTrusted) e.preventDefault() }}
		>
			<RadioGroupItem value={value} id={id} />
			<span className="text-sm leading-none font-[500] text-(--color-foreground)">
				{label}
			</span>
		</Label>
	)
}

RadioOption.displayName = 'RadioOption'

export interface CheckboxOptionProps {
	id: string
	label: string
	checked: boolean
	onCheckedChange: (checked: boolean) => void
}

function CheckboxOption({ id, label, checked, onCheckedChange }: CheckboxOptionProps) {
	return (
		<Label htmlFor={id} className="relative flex items-center gap-2 cursor-pointer" onClick={(e) => { if (!e.isTrusted) e.preventDefault() }}>
			<Checkbox
				id={id}
				name={id}
				checked={checked}
				onCheckedChange={(c) => onCheckedChange(c === true)}
			/>
			<span className="text-sm leading-none font-[500] text-(--color-foreground)">
				{label}
			</span>
		</Label>
	)
}

CheckboxOption.displayName = 'CheckboxOption'

export { RadioOption, CheckboxOption }
